module.exports = __webpack_public_path__ + "img/portal-museum.879611e1.jpg";